var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22068 2.82264H2.82068V3.22264V5.93356V6.33356H3.22068H5.9316H6.3316V5.93356V3.22264V2.82264H5.9316H3.22068ZM3.22068 13.6663H2.82068V14.0663V16.7772V17.1772H3.22068H5.9316H6.3316V16.7772V14.0663V13.6663H5.9316H3.22068ZM16.7753 6.33356H17.1753V5.93356V3.22264V2.82264H16.7753H14.0644H13.6644V3.22264V5.93356V6.33356H14.0644H16.7753ZM17.1888 17.1772H19.0997V19.0881H17.1888V17.1772ZM16.3888 16.3772H14.4779V14.4663H16.3888V16.3772ZM13.6779 13.6663H11.767V11.7554H13.6779V13.6663ZM17.1888 13.6663V11.7554H19.0997V13.6663H17.1888ZM8.24252 8.24447H0.909766V0.911719H8.24252V8.24447ZM8.24252 11.7554V19.0881H0.909766V11.7554H8.24252ZM11.7534 0.911719H19.0862V8.24447H11.7534V0.911719Z",
    fill: "#888B94",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.257fb614aedf1c89ab61756617f909db.svg";
export { ForwardRef as ReactComponent };